import React, { useState, useEffect } from "react";
import { FormControlLabel, Switch } from '@curves/ui-base';
import { Overview, OverflowMenu } from '@curves/ui-shared';

import { useCustomerResourceContext } from "@Local/CustomerResource/Components/CustomerResourceContext";
import useCustomerResourceApi from "@Apis/useCustomerResourceApi";
const CustomerResourceEnableSwitch = (props) => {
    const { defaultValue, sourceID } = props;
    const { putCustomerResourceEnableApi } = useCustomerResourceApi();
    const [isEnabled, setIsEnabled] = useState(defaultValue);
    const [isLoading, setIsLoading] = useState(false);
    // 當 defaultValue 改變時更新本地狀態
    useEffect(() => {
        setIsEnabled(defaultValue);
    }, [defaultValue]);
    const handleCustomerResourceEnableApi = async (sourceID, params) => {
        try {
            const resp = await putCustomerResourceEnableApi(sourceID, params);
            if (resp) {
                // 成功後不調用 refresh，保持當前狀態
            }
        } catch (error) {
            // 失敗時恢復原狀態
            setIsEnabled(defaultValue);
        } finally {
            // 重置載入狀態，讓按鈕可以再次點擊
            setIsLoading(false);
        }
    };
    const handleChangeSwitch = (e, checked) => {
        if (isLoading) return;
        setIsEnabled(checked);
        setIsLoading(true);
        const params = { enabled: checked };
        handleCustomerResourceEnableApi(sourceID, params);
    };
    return (
        <FormControlLabel 
            className={'m-0'} 
            control={
                <Switch 
                    checked={isEnabled}
                    onChange={handleChangeSwitch}
                    disabled={isLoading}
                />
            } 
        />
    );
};
const headerRow = [
	{ 
        cellKey: "sort", 
        headerLabel: "順序",
        style: { minWidth: 50 },
    },
	{ 
        cellKey: "sourceName", 
        headerLabel: "項目名稱",
        style: { minWidth: 50 },
    },
	{ 
        cellKey: "sourceNote", 
        headerLabel: "項目說明",
        style: { minWidth: 50 },
    },
	{
		cellKey: "enabled",
		headerLabel: "是否生效",
		align: "center",
		style: { minWidth: 50 },
		formatCell: (isEnabled, { sourceID }) => {
			return <CustomerResourceEnableSwitch defaultValue={isEnabled} sourceID={sourceID} />;
		},
	},
	{
		cellKey: "more",
		headerLabel: "",
		width: 6.8,
		style: { minWidth: 50 },
		formatCell: (value, rowData, { openCustomerResourceDialog, refresh }) => {
			const menuData = [
				{
					text: "編輯",
					onClick: e => {
						openCustomerResourceDialog(rowData, refresh);
					},
				},
			];
			return <OverflowMenu menuData={menuData} actionMenuProps={{ className: "more-label-box-menu align-left" }} />;
		},
	},
];
const CustomerResourceTable = () => {
    const { addDialogRef, refresh, bookmark, setBookmarkNum, sourceData } = useCustomerResourceContext();
    const { pageIndex = 1, totalCount = 0, totalPage = 0, list = [] } = sourceData || {};
    const { pageSize = 20 } = bookmark;
    const handleChangePage = (e, num) => {
        if (typeof setBookmarkNum === 'function') setBookmarkNum(num);
    };
    const updateOverviewPage = (num) => {
        if (document.activeElement) document.activeElement.blur();
        handleChangePage(null, num);
    };
    const contextValue = {
        overviewData: { list, pagination: { pageIndex, pageSize, totalCount, totalPage } },
        updateOverviewPage,
    };
    const handleOpenCustomerResourceDialog = (rowData, refresh) => {      
        if (addDialogRef.current && addDialogRef.current.openCustomerResourceDialog) {
            addDialogRef.current.openCustomerResourceDialog(rowData, refresh);
        }
    };
	return (
		<Overview contextValue={contextValue} idKey="sourceID">
			<Overview.Table
				headerRow={headerRow}
                cardProps={{ className: 'theme-gray' }}
				cellRenderContext={{ refresh, openCustomerResourceDialog: handleOpenCustomerResourceDialog }}
			/>
			<Overview.Pagination className="mt-4" />
		</Overview>
	);
};
export default CustomerResourceTable;
